// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectedFile[data-v-5157c6e9]{border:2px solid #f90}", ""]);
// Exports
module.exports = exports;
